import { useTranslation } from "react-i18next";
import { Text } from "components/text";
import { MANUSCRIPT_PROCESSING_STATUSES } from "integrations/firebase/collections/manuscriptProcessingReporting";
import { cn } from "utils";
import { STATUS_PRESENTATION } from "../utils/manuscriptProcessingStatusPresentation";

export const ManuscriptProcessingStatusTiles = ({
  counts,
}: {
  counts: Record<string, number | undefined>;
}) => {
  const { t } = useTranslation("settings");

  return (
    <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4 2xl:grid-cols-8">
      {MANUSCRIPT_PROCESSING_STATUSES.map((status) => {
        const { Icon, label, tileIconClassName } = STATUS_PRESENTATION[status];

        return (
          <div
            key={status}
            className="rounded-xl border border-secondary-200 p-4"
            data-testid={`manuscript-processing-tile-${status}`}
          >
            <div className="flex items-center gap-2">
              <Icon
                aria-hidden
                className={cn("size-4 shrink-0", tileIconClassName)}
              />
              <Text as="dt" variant="caption" className="leading-tight">
                {label(t)}
              </Text>
            </div>
            <Text as="dd" variant="heading" numeric="tabular" className="mt-2">
              {counts[status] ?? "-"}
            </Text>
          </div>
        );
      })}
    </dl>
  );
};
